
//スクリーンをOFFにしない
let wakeLock:WakeLockSentinel|null = null;

// create an async function to request a wake lock
export const startWakeLock = (onRelease?:()=>void):Promise<void> =>  {
    return navigator.wakeLock.request("screen").then((result)=>{
        wakeLock = result;
        //リリースを検知したければ登録する
        if(onRelease){
            wakeLock.addEventListener("release", onRelease);
        }
    }).catch((e)=>{
        // if wake lock request fails - usually system related, such as battery
        console.error("wakelock failed:", e);
    });    
};

export const endWakeLock = ()=>{
    if (wakeLock !== null) {
        wakeLock.release().then(() => {
            wakeLock = null;
        });
    }
}
